function dcStudentUsageDetailController() {
  const vm = this;
  vm.progress = vm.usageDetails;
}
export default dcStudentUsageDetailController;
